import { ClockCounterClockwise } from "@phosphor-icons/react";

export const LedgerPanel = ({ ledger }) => (
  <div className="rounded-md border border-slate-200 bg-white" data-testid="stock-ledger-panel">
    <div className="border-b border-slate-200 p-4">
      <h2 className="flex items-center gap-2 text-base font-bold text-slate-900 md:text-lg">
        <ClockCounterClockwise size={18} weight="duotone" /> Stock Movement History
      </h2>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 bg-slate-50 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">
            <th className="p-3">Date</th>
            <th className="p-3">Item</th>
            <th className="p-3">Type</th>
            <th className="p-3 text-right">Change</th>
            <th className="p-3 text-right">Balance</th>
            <th className="p-3">Reason</th>
            <th className="p-3">Order #</th>
            <th className="p-3">Note</th>
            <th className="p-3">By</th>
          </tr>
        </thead>
        <tbody data-testid="stock-ledger-table-body">
          {ledger.length === 0 && (
            <tr><td colSpan={9} className="p-5 text-center text-slate-400">No stock movements yet.</td></tr>
          )}
          {ledger.map((e) => (
            <tr key={e.id} className="border-b border-slate-100 hover:bg-slate-50">
              <td className="p-3 whitespace-nowrap text-xs text-slate-500">{e.created_at.slice(0, 16).replace("T", " ")}</td>
              <td className="p-3 font-medium">{e.item_name}</td>
              <td className="p-3 text-xs text-slate-500">{e.type === "product" ? "Product" : "Raw material"}</td>
              <td className={`p-3 text-right font-mono font-semibold ${e.change >= 0 ? "text-emerald-600" : "text-red-600"}`}>
                {e.change >= 0 ? "+" : ""}{e.change} {e.unit}
              </td>
              <td className="p-3 text-right font-mono">{e.balance_after} {e.unit}</td>
              <td className="p-3 text-xs">{e.reason === "dispatch" ? "Dispatch deduction" : e.reason === "adjustment" ? "Correction" : "Stock in"}</td>
              <td className="p-3 font-mono text-xs">{e.order_number || "—"}</td>
              <td className="p-3 text-xs text-slate-500">{e.note || "—"}</td>
              <td className="p-3 text-xs text-slate-500">{e.by}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
